import React from 'react';
import { AGENT } from '@/data/agent';
import { LANDING } from '@/constants/testIds';

const items = [
  { value: AGENT.careerVolume, label: 'Career sales volume' },
  { value: `${AGENT.rating.toFixed(1)}★`, label: `RateMyAgent (${AGENT.reviewCount} reviews)` },
  { value: AGENT.yearsOnCoast, label: 'Years on the Coast' },
  { value: AGENT.areas.length.toString(), label: 'Suburbs served' },
];

const Stats = () => {
  return (
    <section
      data-testid={LANDING.stats}
      className="bg-bayleys-navy text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12 lg:py-16 grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="flex flex-col items-start border-l border-white/15 pl-5 lg:pl-7"
          >
            <span className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
              {item.value}
            </span>
            <span className="mt-2 text-xs sm:text-sm tracking-wider uppercase text-white/60 font-medium">
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
